import { render, staticRenderFns } from "./Visit-Team-Detail.vue?vue&type=template&id=b49fabb0"
import script from "./Visit-Team-Detail.vue?vue&type=script&lang=js"
export * from "./Visit-Team-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports